<script lang="ts">
import Auth from "./auth.svelte";
import { fetchAccessToken, mastodonAccessToken } from './store'
import Watch from "./watch.svelte";

async function checkRedirected() {
	const queries = new URLSearchParams(location.search)
	if(queries.has('code')) {
		await fetchAccessToken(queries.get('code'))
		location.href = '/'
	}
}

if(mastodonAccessToken) {
	checkRedirected()
}
</script>

<main>
	<div class="outer">
		<h1>読み上げちゃん</h1>
		<p>Mastodonのタイムラインを読み上げます</p>
		<Auth />
		<Watch />
	</div>
</main>

<style>
	.outer {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	main {
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		font-size: 4em;
		font-weight: 100;
		margin-bottom: 0;
	}
	p {
		margin-top: 0;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>